import { render, staticRenderFns } from "./referenceBook.vue?vue&type=template&id=1911e8c3&scoped=true&"
import script from "./referenceBook.vue?vue&type=script&lang=js&"
export * from "./referenceBook.vue?vue&type=script&lang=js&"
import style0 from "./referenceBook.vue?vue&type=style&index=0&id=1911e8c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1911e8c3",
  null
  
)

export default component.exports